// extracted by mini-css-extract-plugin
export default {"visitsFooter":"VisitsFooter_visitsFooter__rF4t1","content":"VisitsFooter_content__5P7oF"};